"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTyped = void 0;
var tslib_1 = require("tslib");
var rxjs_1 = require("rxjs");
/**
 * @description combineLatest wrapper to apply better type check.
 *
 * In RxJS v6.5.1, type definition of combineLatest is like
 *
 * ```
 * export declare function merge<T>(v1: ObservableInput<T>): Observable<T>;
 * export declare function merge<T>(v1: ObservableInput<T>, concurrent?: number): Observable<T>;
 * export declare function merge<T, T2>(v1: ObservableInput<T>, v2: ObservableInput<T2>): Observable<T | T2>;
 * export declare function merge<T, T2>(v1: ObservableInput<T>, v2: ObservableInput<T2>, concurrent?: number): Observable<T | T2>;
 * export declare function merge<T, T2, T3>(v1: ObservableInput<T>, v2: ObservableInput<T2>, v3: ObservableInput<T3>): Observable<T | T2 | T3>;
 * export declare function merge<T, R>(...observables: (ObservableInput<any> | number)[]): Observable<R>;
 * ```
 */
var mergeTyped = function () {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return rxjs_1.merge.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(observables), false));
};
exports.mergeTyped = mergeTyped;
